import { Form } from 'antd';
import Box from 'components/Box';
import React from 'react';
import { IStaffListChooseUIRef, StaffListChooseUI } from './Staff';
import { IStaffItemData } from 'services/shop/types/staff';
import { IQuickBookingV2ServiceItem } from './type';
type Props = {
  staffRef: React.RefObject<IStaffListChooseUIRef>;
  onPickStaff: (item: IStaffItemData) => void;
};
const QuickBookingStaffContent = ({ staffRef, onPickStaff }: Props) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      style={staffContainerStyle}
    >
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const staffIds = getFieldValue('services')?.map(
            (o: IQuickBookingV2ServiceItem) => o.staffId
          );
          const staffs = getFieldValue('staffs');
          return (
            <StaffListChooseUI
              staffs={staffs}
              ref={staffRef}
              onPickStaff={onPickStaff}
              selectedStaffs={staffIds}
            />
          );
        }}
      </Form.Item>
    </Box>
  );
};

export default QuickBookingStaffContent;
const staffContainerStyle: React.CSSProperties = { minWidth: 750, overflow: 'auto' };